import React from 'react';
import styled, { css } from 'styled-components';
import User from 'icons/src/User';

const CTA = () => (
  <Link notOnMobile href="https://onlineautomotivesalesacademy.pauldevries1972.nl/">
    <User />
    <Label>Login Academy</Label>
  </Link>
);

export default CTA;

const Link = styled.a`
  justify-self: flex-end;
  display: flex;
  align-items: center;
  height: 2.25rem;
  width: 2.25rem;
  justify-content: space-around;
  color: ${({ theme }) => theme.primaryColor};
  text-decoration: none;
  border: 1px solid ${({ theme }) => theme.primaryColor};
  border-radius: 5rem;
  font-size: .75rem;
  font-weight: 700;

  ${({ notOnMobile }) => notOnMobile && css`
    display: none;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      display: flex;
    }
  `}

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    width: auto;
    padding: 0 .75rem;
    justify-content: initial;
    border-radius: 0;
    border: none;
    border-left: 1px solid ${({ theme }) => theme.primaryColor};
  }

  &:hover {
    background-color: ${({ theme }) => theme.primaryColor};
    color: white;
  }

  svg {
    width: 1rem;
  }
`;

const Label = styled.span`
  display: none;
  margin-left: .5rem;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    display: inline;
  }
`;
